import React from 'react';
import { Card, CardActions, CardContent, Typography, Box } from '@mui/material';

const HelpCard = ({ title, description, linkText, icon, iconType, onClick }) => {
  const renderIcon = () => {
    if (iconType === 'mui') return icon;
    if (iconType === 'svg') {
      const SvgIcon = icon;
      return <SvgIcon style={{ width: 40, height: 40 }} />;
    }
    if (iconType === 'image') {
      return <img src={icon} alt={title} style={{ width: 40, height: 40 }} />;
    }
    return null;
  };

  return (
    <Card
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'box-shadow 0.2s, border-color 0.2s',
        border: '1px solid rgba(0,0,0,0.12)',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
          borderColor: '#ccc'
        },
      }}
    >
      <CardContent sx={{ padding: "16px 16px 8px 16px", flexGrow: 1 }}>
        <Box sx={{ mb: "2px" }}>{renderIcon()}</Box>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0 }}>
          {description}
        </Typography>
      </CardContent>
      <CardActions sx={{ padding: "0px 16px 16px 16px" }}>
        <Typography variant="body2" color="primary">
          {linkText}
        </Typography>
      </CardActions>
    </Card>
  );
};

export default HelpCard;
